export default "__VITE_ASSET__bb05aa9c__"